import React, { useEffect, useState } from 'react';
import { Typography, Box, Grid } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow'; 
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { EffectCoverflow, Autoplay } from 'swiper/modules'; 
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from 'react-i18next';


const ProjectsSection = () => {
  const { t } = useTranslation();

  const projects = t('projectsSection.projects', { returnObjects: true });


  useEffect(() => {
      AOS.init({ duration: 1000 });
    }, []);

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
      AOS.init({ duration: 1000 });
  
      const handleResize = () => {
        setWindowWidth(window.innerWidth); 
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);


    return (
      <section
        id="projects"
        style={{
          paddingTop: "14vh",
          color: "white",
          position: "relative",
          minHeight: "100vh",
        }}
      >
        <h1 data-aos="fade-up" style={{ textAlign: "center", marginBottom: "40px" }}>
          {t('projectsSection.title')}
        </h1>
  
        {projects.map((project, index) => (
          <Box
            key={index}
            data-aos="fade-up" 
            sx={{
              padding: "25px",
              marginBottom: index === projects.length - 1 ? "20px" : "80px",
              background: "rgba(255, 255, 255, 0.1)",
              borderRadius: "10px",
              boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.2)",
              marginLeft: "auto",
              marginRight: "auto",
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              maxWidth: "1000px", 
              width: { xs: "80%", sm: "80%", md: "80%" },
              transition: "all 0.3s ease",
              "&:hover": {
                boxShadow: "0px 8px 18px rgba(64, 224, 208, 0.5)", 
                borderColor: "#40e0d0",
              },
            }}
          >
            <Grid container spacing={3}>
              {/* Caja izquierda (Texto) */}
              <Grid item xs={12} sm={12} md={6}>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                  <Typography
                    variant="h4"
                    color="#40e080"
                    gutterBottom
                    sx={{ fontSize: { xs: "1.3rem",sm:"1.8rem" , md: "1.8rem" }, fontWeight: 'bold' }}
                  >
                    {project.title}
                  </Typography>
                  <Typography variant="body1" color="white" sx={{ marginBottom: { xs: "10px", sm: '20px', md: "20px" }, fontSize: { xs: "0.9rem", sm:"1.1rem", md: "1.1rem" } }}>
                    {project.description}
                  </Typography>
                  <Typography variant="subtitle1" color="lightgray" sx={{ marginBottom: { xs: "0px", md: "10px" }, fontSize: { xs: "0.9rem", sm:"1.1rem", md: "1.1rem" }}}>
                    <strong>{t('projectsSection.platform')}:</strong> {project.platform}
                  </Typography>
                  <Typography variant="subtitle1" color="lightgray" sx={{ fontSize: { xs: "0.9rem", sm:"1.1rem", md: "1.1rem" }}}>
                    <strong>{t('projectsSection.technologies')}:</strong> {project.technologies.join(", ")}
                  </Typography>
                </Box>
              </Grid>
  
              {/* Caja derecha (Carrusel) */}
              <Grid item xs={12} sm={12} md={6}>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <Swiper
                    key={windowWidth} 
                    spaceBetween={10}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{ delay: 5000 }}
                    effect="coverflow"
                    grabCursor={true}
                    modules={[EffectCoverflow, Autoplay]}
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "10px",
                    }}
                    bbreakpoints={{
                      640: {
                        slidesPerView: 1,
                        width: "100%", 
                      },
                      768: {
                        slidesPerView: 1,
                        width: "100%",  
                      },
                      1024: {
                        slidesPerView: 1,
                        width: "100%",  
                      },
                      1200: { 
                        slidesPerView: 1,
                        width: "100%",
                        height: 'auto', 
                      },
                    }}
                  >
                    {project.imageUrls.map((imageUrl, idx) => (
                      <SwiperSlide key={idx}>
                        <img
                          src={imageUrl}
                          alt={`Imagen del proyecto ${project.title} ${idx + 1}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "10px",
                            boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
                          }}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Box>
              </Grid>
            </Grid>
          </Box>
        ))}
  
      </section>
    );

};




export default ProjectsSection;